import cartReducer from './reducers';

export default cartReducer;
